import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@material-ui/core';

interface CoordenadoresConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const CoordenadoresConfirmationDialog: React.FC<CoordenadoresConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="coordenadores-confirmation-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="coordenadores-confirmation-dialog-title">Atenção</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Foi detectado delimitações alocadas pelo coordenador Líder, ao editar os coordenadores as delimitações deverão ser feitas novamente.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={isLoading}>
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          color="primary" 
          variant="contained" 
          autoFocus
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isLoading ? 'Processando...' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CoordenadoresConfirmationDialog;
